import { render } from "./BusquedaXPlacaCambio.vue?vue&type=template&id=db538860&scoped=true"
import script from "./BusquedaXPlacaCambio.vue?vue&type=script&lang=js"
export * from "./BusquedaXPlacaCambio.vue?vue&type=script&lang=js"

import "./BusquedaXPlacaCambio.vue?vue&type=style&index=0&id=db538860&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db538860"]])

export default __exports__